import { API_BASE_URL } from "../utils/constants";
import apiClient from "./client";

export async function fetchCategoryLeaderboard(slug, signal) {
  if (!slug) {
    return { category: null, results: [] };
  }

  const res = await fetch(
    `${API_BASE_URL}/api/leaderboard/${slug}/`,
    { signal }
  );

  if (!res.ok) {
    return { category: slug, results: [] };
  }

  return res.json();
}

export async function fetchLeaderboards({ type = "general", category, limit = 20 } = {}, signal) {
  const params = { type, limit };
  if (category) {
    params.category = category;
  }

  const response = await apiClient.get("leaderboards/", {
    params,
    signal,
  });

  return response.data;
}

export async function fetchTeamLeaderboards({ type = "general", category, limit = 20 } = {}, signal) {
  const params = { type, limit };
  if (category) {
    params.category = category;
  }

  const response = await apiClient.get("team-leaderboards/", {
    params,
    signal,
  });

  return response.data;
}
